<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleRighe > 0"
      color="blue lighten-4"
      item-key="rigaCodice"
      :headers="headers"
      :items="righeDocumento"
      :options.sync="options"
      :server-items-length="totaleRighe"
      :loading="loading"
      class="elevation-1"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      dense
    >
      <template v-slot:[`item.prezzo`]="{ item }">
        {{ item.prezzo | euro }}
      </template>
      <template v-slot:[`item.valore`]="{ item }">
        {{ item.valore | euro }}
      </template>
      <template v-slot:[`item.sconto`]="{ item }">
        {{ item.sconto | euro }}
      </template>
      <template v-slot:[`item.scontoPerc`]="{ item }">
        {{ item.scontoPerc + ' %'}}
      </template>
      <template v-slot:[`item.importo`]="{ item }">
        {{ item.importo | euro }}
      </template>
      <template v-slot:[`item.aliquota`]="{ item }">
        {{ item.aliquota + ' %'}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import scontrini from '@/services/scontriniService.js'
  import _ from 'lodash'
  
  export default {
    components: {
    },
    props: {
      idDocumento: String
    },
    data () {
      return {
        totaleRighe: 0,
        righeDocumento: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Codice', value: 'codice', align: 'start'},
          { text: 'Descrizione', value: 'prodotto' },
          { text: 'Quantità', value: 'quantita', align: 'end' },
          { text: 'Prezzo Unitario', value: 'prezzo' , align: 'end'},
          { text: 'Prezzo Totale', value: 'valore' , align: 'end'},
          { text: 'Sconto', value: 'sconto' , align: 'end'},
          { text: 'Sconto%', value: 'scontoPerc' , align: 'end'},
          { text: 'Importo', value: 'importo' , align: 'end'},
          { text: 'Iva %', value: 'aliquota' , align: 'center'}
        ],
        expanded: [],
        singleExpand: false,
        modelloDocumento: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreDocumento: ''
      }
    },
    computed: {
      refreshList() { // Verificare
        return this.$store.getters['documenti/refreshDettaglioScontrini']
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'dettaglioScontrini')
        }
      },
      async idDocumento(value) {
        if (value) {
          await this.getDataFromApi()
        }
      }
    },
    async mounted () {
    },
    methods: {
      async onRicerca(filtri) {
        this.filtri = filtri
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          const documento = await scontrini.getRigheScontrino(this.idDocumento)
          this.righeDocumento = documento.rows.filter(x => x.quantita > 0)
          this.totaleRighe = this.righeDocumento.length
        } catch(err) {
          this.righeDocumento = []
          this.totaleRighe = 0
        } finally {
          this.loading = false
        }
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.scontriniSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
